import Vue from 'vue';
import VueLogger from 'vuejs-logger'

const isProduction = process.env.NODE_ENV === 'production'

const logger =  {
    isEnabled: true,
    logLevel : isProduction ? 'error' : 'debug',
    stringifyArguments : false,
    showLogLevel : true,
    showMethodName : true,
    separator: '|',
    showConsoleColors: true
}

const LoggerService = {
    init() {
        Vue.use(VueLogger, logger);
    }
}

export default LoggerService;
